module.exports = __webpack_public_path__ + "static/20180725_211955_optimized-791b02697ccf6cf8a6049780e2f93027.jpg";